import React, {useState} from 'react';
import {Modal} from 'antd';
import {recordProxy} from '../../util';

import Icon1 from './imgs/choose-type-modal1.svg';
import Icon2 from './imgs/choose-type-modal2.svg';
import Icon3 from './imgs/choose-type-modal4.svg';

export default function ChooseTypeModal(props: any) {
    const {history, anchor, zd} = props;
    const [isModalOpen, setIsModalOpen] = useState(true);
    const onCancelModal = () => {
        recordProxy('attest-choose-type-modal', 'click', 'close-btn');
        setIsModalOpen(false);
    };
    const addUrlParam = () => {
        let urlParam = '';
        const tempArr = [
            {name: 'anchor', value: anchor},
            {name: 'zd', value: zd}
        ];
        const urlArr = tempArr.filter(val => val.value);

        urlArr.map((val, key) => {
            if (key !== 0) {
                urlParam += `&${val.name}=${val.value}`;
            } else {
                urlParam += `?${val.name}=${val.value}`;
            }
        });
        return urlParam;
    };
    const goUrl = (type) => {
        setIsModalOpen(false);
        const urlParam = addUrlParam();
        const tempType = {
            'attest': `/attest${urlParam}`,
            'mark': '/mark?pagef=attest-ap-modal'
        };
        recordProxy('attest-choose-type-modal', 'click', type);
        history.push(tempType[type]);
    };
    return (
        <Modal
            title=""
            open={isModalOpen}
            footer={null}
            centered
            onCancel={onCancelModal}
            wrapClassName="choose-type-modal"
            className="attest-choose-type-modal"
            maskClosable={false}
            width={460}
        >
            <div className="">
                <div className="attest-choose-type-modal-title">
                    请选择符合您诉求的服务
                </div>
                <div className="attest-choose-type-modal-subtitle">
                    点击后可直接跳转至对应页面
                </div>
                <div className="attest-choose-type-modal-content">
                    <div
                        className="attest-choose-type-modal-item"
                        onClick={() => goUrl('attest')}
                    >
                        <div>
                            <img className="item-icon" src={Icon1} />
                            <span className="item-tip">付费认证您的企业号码</span>
                        </div>
                        <div>
                            <span className="go-auth-btn">去认证</span>
                            <img src={Icon2} />
                        </div>
                    </div>
                    <div className="attest-choose-type-modal-item"
                        style={{marginBottom: '16px'}}
                        onClick={() => goUrl('mark')}
                    >
                        <div className="item-wrap">
                            <img className="item-icon" src={Icon3} />
                            <div>
                                <div className="item-tip">投诉骚扰诈骗等不良号码</div>
                                <div className="item-subtip">百度&12321合作共建</div>
                            </div>
                        </div>
                        <div>
                            <span className="go-auth-btn">去投诉</span>
                            <img src={Icon2} />
                        </div>
                    </div>

                </div>
            </div>
        </Modal>
    );
}
